<template>
  <div
    class="modal modal-bottom fade"
    :class="{ 'mlx-terms-preview': viewOnly }"
    id="bottom_modal_terms"
    tabindex="-1"
    role="dialog"
    aria-labelledby="bottom_modal"
    style="z-index: 10000"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header" style="border: 0; padding: 0.1rem 1rem">
          <!-- <h5 class="modal-title">Bottom Modal Title</h5> -->
          <button
            type="button"
            class="btn-close text-dark"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body mlx-terms" :style="{ '--mlx-accent': themeColorTheme2 }">
          <div class="mlx-terms-inner">
            <h2 class="mlx-terms-title">
              {{ $t('signUp.pdpaTitle') }}
            </h2>
            <p class="mlx-terms-subtitle">
              {{ $t('signUp.pdpaIntro') }}
            </p>
            <!-- MTH078: PDPA body is static i18n copy — MOO has no merchant-PDPA
                 endpoint (unlike advocado's /advocado/get-merchant-pdpa). -->
            <div class="mlx-terms-body">
              <p>{{ $t('signUp.pdpaBody1', { brand: merchantBrandName }) }}</p>
              <p>{{ $t('signUp.pdpaBody2', { brand: merchantBrandName }) }}</p>
              <p>{{ $t('signUp.pdpaBody3', { brand: merchantBrandName }) }}</p>
              <p>{{ $t('signUp.pdpaBody4', { brand: merchantBrandName }) }}</p>
            </div>
            <!-- MTH070: the two links sit inside the sentence, so the whole line is
                 one translatable message with named slots — glued fragments would
                 break word order in zh/ja/ko/th. -->
            <template v-if="!viewOnly">
              <label class="mlx-terms-agree">
                <input
                  type="checkbox"
                  class="mlx-terms-checkbox"
                  v-model="agreed"
                />
                <i18n-t
                  keypath="signUp.pdpaAgree"
                  tag="span"
                  class="mlx-terms-links"
                  scope="global"
                >
                  <template #pdpaNotice
                    ><a class="cursor-pointer" @click.prevent.stop="termServiceDetail()">{{
                      $t('signUp.pdpaNotice')
                    }}</a></template
                  >
                  <template #privacy
                    ><a class="cursor-pointer" @click.prevent.stop="privacyPolicyDetail()">{{
                      $t('signIn.privacyPolicy')
                    }}</a></template
                  >
                </i18n-t>
              </label>
              <div class="mlx-terms-actions">
                <material-button
                  class="mlx-terms-btn mlx-terms-btn-secondary"
                  @click="decline"
                  >{{ $t('signUp.pdpaDecline') }}
                </material-button>
                <material-button
                  class="mlx-terms-btn"
                  :style="`background: ${buttonColorTheme2} !important; color: #fff !important;`"
                  :disabled="!agreed"
                  @click="agree"
                  >{{ $t('signUp.pdpaContinue') }}
                </material-button>
              </div>
            </template>
          </div>
        </div>
      </div>
      <button
        class="bottom_modal_terms"
        style="display: none"
        data-bs-toggle="modal"
        data-bs-target="#bottom_modal_terms"
      >
        Show Model
      </button>
    </div>
  </div>
</template>

<script>
import MaterialButton from "@/components/MaterialButton.vue";
import $ from "jquery";
import { localStorageName, getMerchantCode } from "@/config/utils";

export default {
  name: "TermService",
  components: {
    MaterialButton,
  },
  props: {
    phone: {
      type: String,
    },
    agree: {
      type: Function,
      default: () => { },
    },
    // MTH0xx: footer "Terms of Service"/"Privacy Policy" links open this same
    // modal before the member has entered/validated a phone number — in that
    // context it's just informational (no checkbox, no Decline/Continue).
    viewOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      merchantCode: "",
      merchantBrandName: "",
      branchCode: "",
      tableCode: "",
      from: "",
      agreed: false,
    };
  },
  computed: {
    themeColorTheme2() {
      return this.$store.state.mainThemeColorTheme2
        ? this.$store.state.mainThemeColorTheme2
        : this.$store.state.color;
    },
    buttonColorTheme2() {
      return this.$store.state.primaryButtonColorTheme2
        ? this.$store.state.primaryButtonColorTheme2
        : this.themeColorTheme2;
    },
  },
  mounted() {
    const code = getMerchantCode();
    this.merchantCode = code ? `/${code}` : "";
    const brandName = localStorage.getItem(localStorageName("MERCHANT_BRAND_NAME"), "");
    this.merchantBrandName = code ? brandName : "";
    this.branchCode = this.$route.query.branch_code ?? this.$route.params.branch_code ?? '';
    this.tableCode = this.$route.query.table_code ?? this.$route.params.table_code ?? '';
    this.from = this.$route.query.from ?? '';
    // MTH078: the modal is opened/closed by Bootstrap (jQuery triggers), so the
    // consent tick has to be cleared on Bootstrap's own close event — a native
    // listener, since jQuery would read ".bs.modal" as an event namespace.
    this.$el.addEventListener("hidden.bs.modal", this.resetAgreed);
  },
  unmounted() {
    this.$el.removeEventListener("hidden.bs.modal", this.resetAgreed);
  },
  methods: {
    resetAgreed() {
      this.agreed = false;
    },
    decline() {
      $(".btn-close").click();
    },
    termServiceDetail() {
      $(".btn-close").click();
      this.$router.push({ path: this.merchantCode + "/terms-service", query: { phone: this.phone, branch_code: this.branchCode, table_code: this.tableCode, from: this.from } });
    },
    privacyPolicyDetail() {
      $(".btn-close").click();
      this.$router.push({ path: this.merchantCode + "/privacy-policy", query: { phone: this.phone, branch_code: this.branchCode, table_code: this.tableCode, from: this.from } });
    },
  },
};
</script>
<style scoped>
.bg-color-common {
  color: #fff;
}

/* MTH008 — theme2 reskin of the consent popup */
/* MTH078 — reshaped to the advocado PDPA consent sheet */
/* Constrain the sheet to the mobile frame (matches theme2 login max-width) */
#bottom_modal_terms .modal-dialog {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
}
#bottom_modal_terms .modal-content {
  border-radius: 24px 24px 0 0;
  box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.08);
}
.mlx-terms {
  padding: 8px 20px 28px !important;
}
.mlx-terms-inner {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  text-align: left;
  max-width: 480px;
  margin: 0 auto;
}
.mlx-terms-title {
  font-size: 24px;
  font-weight: 800;
  line-height: 1.35;
  letter-spacing: -0.02em;
  color: var(--mlx-accent);
  margin: 0 0 8px;
}
.mlx-terms-subtitle {
  font-size: 14px;
  line-height: 1.5;
  color: #857372;
  margin: 0 0 16px;
}
.mlx-terms-body {
  max-height: 35vh;
  overflow-y: auto;
  font-size: 14px;
  line-height: 1.6;
  color: #857372;
  padding-right: 6px;
  margin: 0 0 20px;
}
/* Preview mode (footer links, no checkbox/actions): let the sheet grow to
   75% of the screen instead of shrink-wrapping the static PDPA copy. */
#bottom_modal_terms.mlx-terms-preview .modal-content {
  height: 75vh;
  display: flex;
  flex-direction: column;
}
#bottom_modal_terms.mlx-terms-preview .modal-body.mlx-terms {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
#bottom_modal_terms.mlx-terms-preview .mlx-terms-inner {
  flex: 1;
  min-height: 0;
}
#bottom_modal_terms.mlx-terms-preview .mlx-terms-body {
  max-height: none;
  flex: 1;
}
.mlx-terms-body p {
  margin: 0 0 12px;
}
.mlx-terms-body p:last-child {
  margin-bottom: 0;
}
.mlx-terms-agree {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  cursor: pointer;
  user-select: none;
  margin: 0 0 20px;
}
.mlx-terms-checkbox {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  margin-top: 2px;
  accent-color: var(--mlx-accent);
  cursor: pointer;
}
.mlx-terms-links {
  font-size: 13px;
  line-height: 1.5;
  color: #857372;
  margin: 0;
}
.mlx-terms-links a {
  color: var(--mlx-accent);
  font-weight: 700;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.mlx-terms-actions {
  display: flex;
  gap: 12px;
}
.mlx-terms-btn {
  flex: 1;
  border: none;
  color: #fff;
  font-weight: 700;
  font-size: 16px;
  padding: 16px;
  border-radius: 16px;
  margin: 0;
  cursor: pointer;
  transition: transform 0.1s ease, opacity 0.2s ease;
}
.mlx-terms-btn:active {
  transform: scale(0.98);
}
.mlx-terms-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.mlx-terms-btn:disabled:active {
  transform: none;
}
.mlx-terms-btn-secondary {
  background: transparent !important;
  border: 2px solid #d7c2c0 !important;
  color: #201a1a !important;
  box-shadow: none !important;
}

/* Css model */
.modal.modal-left .modal-dialog,
.modal.modal-right .modal-dialog,
.modal.modal-top .modal-dialog,
.modal.modal-bottom .modal-dialog {
  -webkit-transform: translate3d(0%, 0, 0);
  -ms-transform: translate3d(0%, 0, 0);
  -o-transform: translate3d(0%, 0, 0);
  transform: translate3d(0%, 0, 0);
}

/* Left & Right */

.modal.modal-left .modal-dialog,
.modal.modal-right .modal-dialog {
  position: fixed;
  margin: auto;
  width: 500px;
  max-width: 100%;
  height: 100%;
}

.modal.modal-left .modal-content,
.modal.modal-right .modal-content {
  height: 100%;
  overflow-y: auto;
}

.modal.modal-left .modal-body,
.modal.modal-right .modal-body {
  padding: 15px 15px 80px;
}

.modal.modal-left.fade .modal-dialog {
  left: -500px;
  -webkit-transition: opacity 0.3s linear, left 0.3s ease-out;
  -moz-transition: opacity 0.3s linear, left 0.3s ease-out;
  -o-transition: opacity 0.3s linear, left 0.3s ease-out;
  transition: opacity 0.3s linear, left 0.3s ease-out;
}

.modal.modal-left.fade.show .modal-dialog {
  left: 0;
}

.modal.modal-right.fade .modal-dialog {
  right: -500px;
  -webkit-transition: opacity 0.3s linear, right 0.3s ease-out;
  -moz-transition: opacity 0.3s linear, right 0.3s ease-out;
  -o-transition: opacity 0.3s linear, right 0.3s ease-out;
  transition: opacity 0.3s linear, right 0.3s ease-out;
}

.modal.modal-right.fade.show .modal-dialog {
  right: 0;
}

.modal.modal-left .modal-content,
.modal.modal-right .modal-content,
.modal.modal-top .modal-content,
.modal.modal-bottom .modal-content,
.modal.modal-full .modal-content {
  border-radius: 0;
  border: none;
}

.modal.modal-left .modal-dialog.modal-sm,
.modal.modal-right .modal-dialog.modal-sm {
  width: 300px;
}

.modal.modal-left .modal-dialog.modal-lg,
.modal.modal-right .modal-dialog.modal-lg {
  width: 800px;
}

.modal.modal-left .modal-dialog.modal-xl,
.modal.modal-right .modal-dialog.modal-xl {
  width: 1140px;
}

/* Top and Bottom */

.modal.modal-top .modal-dialog,
.modal.modal-bottom .modal-dialog {
  position: fixed;
  margin: auto;
  width: 100%;
  max-width: 100%;
  height: auto;
}

.modal.modal-top .modal-content,
.modal.modal-bottom .modal-content {
  height: auto;
  overflow-y: auto;
}

.modal.modal-top .modal-body,
.modal.modal-bottom .modal-body {
  padding: 15px 15px;
}

/* Top */

.modal.modal-top.fade .modal-dialog {
  top: -100%;
  -webkit-transition: opacity 0.3s linear, top 0.3s ease-out;
  -moz-transition: opacity 0.3s linear, top 0.3s ease-out;
  -o-transition: opacity 0.3s linear, top 0.3s ease-out;
  transition: opacity 0.3s linear, top 0.3s ease-out;
}

.modal.modal-top.fade.show .modal-dialog {
  top: 0;
}

/* Bottom */

.modal.modal-bottom.fade .modal-dialog {
  bottom: -100%;
  -webkit-transition: opacity 0.3s linear, bottom 0.3s ease-out;
  -moz-transition: opacity 0.3s linear, bottom 0.3s ease-out;
  -o-transition: opacity 0.3s linear, bottom 0.3s ease-out;
  transition: opacity 0.3s linear, bottom 0.3s ease-out;
}

.modal.modal-bottom.fade.show .modal-dialog {
  bottom: 0;
}

.modal.modal-bottom.fade .modal-dialog {
  bottom: -100%;
}

/* Full Screen */

.modal.modal-full .modal-dialog {
  position: fixed;
  margin: auto;
  width: 100%;
  max-width: 100%;
  height: 100%;
}

.modal.modal-full .modal-content {
  height: 100%;
  overflow-y: auto;
}

.modal.modal-full .close-modal {
  position: fixed;
  top: 0;
  right: 3rem;
}

/* Footer */

.modal-footer-fixed {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #fff;
  border-radius: 0;
}

/* XS */

.modal.modal-left.xs .modal-body,
.modal.modal-right.xs .modal-body {
  padding: 15px;
}

.btn-close {
  font-size: 25px;
  color: #222 !important;
}

.btn-close span {
  color: #222;
}
</style>
